import {
  getIdentityFields,
  getContactFields,
  getAddressFields,
  getBankingFields,
} from "../ClientModal/fieldConfig";

export const getClientDisplayName = (client) => {
  if (!client) return "";
  return client.buyer_type === "LEGAL"
    ? client.legal_company_name || client.name || ""
    : `${client.name || ""} ${client.surname || ""}`.trim();
};

export const getInitials = (name) => {
  if (!name) return "?";
  const parts = name.split(" ").filter(Boolean);
  return parts.slice(0, 2).map((p) => p[0].toUpperCase()).join("") || "?";
};

export const getClientInitials = (client) => getInitials(getClientDisplayName(client));

// Same field configs the create/edit wizard uses — the read-only details
// card mirrors that grouping exactly so "N fields need attention" in the
// wizard and "N left" here always agree.
export const getAllSections = (isNaturalClient) => [
  { title: "Identity", fields: getIdentityFields(isNaturalClient) },
  { title: "Contact", fields: getContactFields(isNaturalClient) },
  { title: "Address", fields: getAddressFields(isNaturalClient) },
  { title: "Banking", fields: getBankingFields() },
];

export const computeCompletion = (clientInfo, isNaturalClient) => {
  const rows = getAllSections(isNaturalClient).flatMap((s) => s.fields);
  const filled = rows.filter((f) => !!clientInfo?.[f.key]).length;
  return {
    filled,
    total: rows.length,
    pct: rows.length ? Math.round((filled / rows.length) * 100) : 0,
  };
};

export const COPYABLE_KEYS = [
  "personal_email",
  "business_email",
  "mobile_phone_number",
  "land_phone_number",
  "iban_ron",
  "iban_euro",
  "social_security_number",
  "legal_fiscal_code",
  "legal_unique_registration_code",
];
